import { createHashedStore } from 'totalinvoice-frontend-core'

const storageKey = "customer"

const defaultValues = {
    customerList: [],
    customerContext: [],
}

// TODO only create store if user is logged in
const store = createHashedStore(storageKey, defaultValues)

function emptyCustomer() {
    return {
        id: null,
        vatno: "",
        title: "",
        first_name: "",
        last_name: "",
        street: "",
        zip_code: "",
        city: "",
        country: "",
        email: "",
        freetext: "",
        isprivate: false,
    }
}

export { store as customerStore, emptyCustomer }
